let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6nrPD")).then(() => parcelRequire('a8CW2'));